import React, { useEffect, useMemo, useRef, useState } from "react";
import Input from "../../components/input";
import Button from "../../components/button";
import Loading from "../../components/loading";
import { OlindaService } from "../../services/apiOlinda";
import { useParams } from "react-router-dom";
import { InputHelper, InputWrapper } from "./style";
import getURLOlindaRequest from "../../utils/getURLOlindaRequest";

function CadastrarServicos(props) {
  const [isError, setIsError] = useState(false);
  const [isSucess, setIsSucess] = useState(false);
  const [modal, setModal] = useState(false);
  const [data, setData] = useState("");
  const [showTable, setShowTable] = useState(false);
  /**
   * @type {import("../../types").useState<string[] | string>}
   */
  const [mensagemErro, setMensagemErro] = useState("");
  const [inputError, setInputError] = useState(false);
  const [mensagemSucess, setMensagemSucess] = useState("");
  // Verificando edicao de servico
  const { id } = useParams();
  const [buttonDisabled, setButtonDisabled] = useState(true);

  //constanteAtualizarServicos
  const [nome_servico, setNome_servico] = useState("");
  const [servico, setServico] = useState("");
  const [url_servico, setUrl_servico] = useState("");
  const [servico_publico, setServicoPublico] = useState(false);
  /**
   * @type {import('../../types').useState<string | null>}
   */
  const [url_servico_pronta, set_url_servico_pronta] = useState("");

  // Verificando preenchimento de input
  const listaAtributosObr = [nome_servico, servico, url_servico];
  const [formError, setFormError] = useState({
    nome_servico: false,
    servico: false,
    url_servico: false,
  });

  const isEditing = Boolean(id);

  const URLProntaValue = useMemo(
    () => (url_servico_pronta ? url_servico_pronta : "consultar-olinda"),
    [url_servico_pronta]
  );
  const URLFullFormat = useMemo(() => {
    return `${process.env.REACT_APP_BASE_URL_BACKEND}/olinda/${URLProntaValue}`;
  }, [URLProntaValue]);

  useEffect(() => {
    if (isEditing) {
      const script = document.createElement("script");

      script.src = "../dsgov.js";
      script.async = true;

      document.body.appendChild(script);
    }
  }, [isEditing]);

  useEffect(() => {
    if (id) {
      fetchService();
    }
  }, []);

  useEffect(() => {
    let error = false;

    listaAtributosObr.forEach((input) => {
      if (input.length <= 0) {
        error = true;
      }
    });

    setButtonDisabled(error);
  }, listaAtributosObr);

  /**
   *
   * @param {import("axios").AxiosError & Error} error
   */
  function setErrorMsg(error) {
    const resposta = error.response ? error.response.data : error.message;
    if (resposta.errors) {
      /**
       * @type {{ [key: string] : string[] }}
       */
      const errors = resposta.errors;
      setMensagemErro(Object.values(errors).flat());
      return;
    }

    if (resposta.message) {
      setMensagemErro(resposta.message);
      return;
    }

    if (resposta) {
      setMensagemErro(resposta);
      return;
    }

    setMensagemErro("Erro desconhecido! Contate um administrador");
  }

  function fetchService() {
    setModal(true);
    setIsError(false);
    setIsSucess(false);

    OlindaService.listarIdServico(id)
      .then((response) => {
        const service = response.data;
        const {
          nome_servico,
          url_servico,
          servico_publico,
          servico,
          url_servico_pronta,
        } = service.data;

        setNome_servico(nome_servico);
        setUrl_servico(url_servico);
        setServicoPublico(servico_publico);
        setServico(servico);

        if (url_servico_pronta) {
          const urlExtraida = getURLOlindaRequest(url_servico_pronta);
          set_url_servico_pronta(urlExtraida);
        }

        setModal(false);
      })
      .catch((error) => {
        setIsError(true);
        setErrorMsg(error);

        setModal(false);
      });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setModal(true);
    setIsError(false);
    setIsSucess(false);
    setShowTable(false);
    setInputError(false);

    if (isEditing) {
      OlindaService.atualizarServicos(
        id,
        nome_servico,
        url_servico,
        servico_publico,
        servico,
        URLFullFormat
      )
        .then((response) => {
          let resposta = response.data;
          setTimeout(function () {
            window.location = "/listar-servicos";
          }, 1500);

          if (!resposta.erro) {
            setMensagemSucess("Dados salvos com sucesso!");
            setIsSucess(true);
            setModal(false);
            setData(resposta.data);
          }
        })
        .catch((error) => {
          setIsError(true);
          setErrorMsg(error);
          setModal(false);
        });
    } else {
      OlindaService.criarServicos(
        nome_servico,
        url_servico,
        servico_publico,
        servico,
        URLFullFormat
      )
        .then((response) => {
          const resposta = response.data["data"];
          const idServico = resposta.id_servicos_olinda;

          setTimeout(function () {
            window.location = `/editar-servico/${idServico}`;
          }, 5000);

          if (!resposta.erro) {
            setData(resposta.data);
            setModal(false);
            setIsSucess(true);
            setMensagemSucess("Dados Salvos com Sucesso");
          }
        })
        .catch((err) => {
          setIsError(true);
          setErrorMsg(err);
          setModal(false);
        });
    }
  };

  function validarInput(event) {
    event.preventDefault();

    const inputId = event.target.id;
    let formErrorTemp = {};

    if (event.target.value <= 0) {
      formErrorTemp = { ...formError };
      formErrorTemp[inputId] = true;
    } else {
      formErrorTemp = { ...formError };
      formErrorTemp[inputId] = false;
    }

    setFormError(formErrorTemp);
  }

  /**
   *
   * @param {string} value
   */
  const handleURLChange = (value) => {
    set_url_servico_pronta(value);
  };

  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <h3 className='text-uppercase text-center '>
        {isEditing ? "Editar" : "Cadastrar"} Serviço
      </h3>

      <form
        id='formulario'
        className='gl-show-field-erros'
        onSubmit={handleSubmit}
      >
        <div style={{ width: "25%", display: "inline-block", padding: "25px" }}>
          <Input
            value={nome_servico}
            id='nome_servico'
            placeholder='Nome do Serviço'
            density='input-highlight'
            label='Nome do Serviço *'
            cus
            change={(e) => {
              validarInput(e);
              setNome_servico(e.target.value);
            }}
            customClass={formError.nome_servico && "danger"}
          />
        </div>
        <div style={{ width: "25%", display: "inline-block", padding: "25px" }}>
          <Input
            value={servico}
            id='servico'
            placeholder='Serviço'
            density='input-highlight'
            label='Serviço *'
            change={(e) => {
              validarInput(e);
              setServico(e.target.value);
            }}
            customClass={formError.servico && "danger"}
          />
        </div>

        <div style={{ width: "25%", display: "inline-block", padding: "25px" }}>
          <Input
            value={url_servico}
            id='url_servico'
            placeholder='Url Do Serviço'
            density='input-highlight'
            label='Url Do Serviço *'
            change={(e) => {
              validarInput(e);
              setUrl_servico(e.target.value);
            }}
            customClass={formError.url_servico && "danger"}
          />
        </div>

        <InputWrapper>
          <Input
            value={url_servico_pronta}
            placeholder={`consultar-olinda`}
            change={(e) => {
              handleURLChange(e.target.value);
            }}
            label='URL de Requisição Olinda'
            density='input-highlight'
          />

          <InputHelper>
            A URL será salva como: "{process.env.REACT_APP_BASE_URL_BACKEND}
            /olinda/<strong>{URLProntaValue}</strong>". Inserir apenas a URL, sem parâmetros.
          </InputHelper>
          <InputHelper>
            <>Exemplo de consulta</>: <strong>{URLFullFormat}</strong>?servico=
            {nome_servico ? nome_servico : "???"}
            {!servico_publico && (
              <>&token_acesso={"{TOKEN_ACESSO_CONSUMIDOR}"}</>
            )}
          </InputHelper>
        </InputWrapper>

        <div
          style={{ width: "100%", display: "inline-block", padding: "25px" }}
        >
          <div className='d-inline-block mr-5'>
            <div className='br-radio'>
              <input
                id='h-radio-4'
                type='radio'
                name='h-radio'
                value='1'
                checked={!servico_publico}
                onClick={(e) => {
                  setServicoPublico(false);
                }}
              />
              <label htmlFor='h-radio-4'>Privado</label>
            </div>
          </div>
          <div className='d-inline-block mr-5'>
            <div className='br-radio'>
              <input
                id='h-radio-5'
                type='radio'
                name='h-radio'
                value='h-radio-5'
                checked={servico_publico}
                onClick={(e) => {
                  setServicoPublico(true);
                }}
              />
              <label htmlFor='h-radio-5'>Público</label>
            </div>
          </div>
        </div>

        <div className='row text-md-center' style={{ paddingLeft: "15%" }}>
          * Campos obrigatórios!
        </div>

        {inputError && (
          <div
            style={{
              width: "30%",
              textAlign: "center",
              margin: "0px auto",
              borderRadius: "6px",
            }}
            className=' alert-danger'
            role='alert'
          >
            <h2>Campos obrigatórios!</h2>
          </div>
        )}

        <div style={{ marginTop: "20px" }}>
          <Button
            isDisabled={buttonDisabled}
            backgroundDiv={false}
            background='primary'
            titulo='Gravar Dados'
            typeButton='submit'
            className='botao'
            onClick={(e) => handleSubmit(e)}
          />
        </div>
      </form>

      {isError && (
        <div
          style={{
            width: "500px",
            textAlign: "center",
            margin: "50px auto",
            borderRadius: "6px",
          }}
          className='alert alert-danger'
          role='alert'
        >
          <h3>Ocorreu um erro!</h3>
          {Array.isArray(mensagemErro) ? (
            mensagemErro.map((msg, idx) => (
              <li key={idx}>
                <span>{msg}</span>
              </li>
            ))
          ) : (
            <li>
              <span>{mensagemErro}</span>
            </li>
          )}
        </div>
      )}

      <Loading showModal={modal} />

      {isSucess && (
        <div>
          <div
            style={{
              width: "500px",
              textAlign: "center",
              margin: "50px auto",
              borderRadius: "6px",
            }}
            className='alert alert-success'
            role='alert'
          >
            <h1>{mensagemSucess}</h1>
          </div>
        </div>
      )}
    </div>
  );
}

export default CadastrarServicos;
